import { render, staticRenderFns } from "./CompanyAccountDetail.vue?vue&type=template&id=8146ab58&scoped=true&"
import script from "./CompanyAccountDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAccountDetail.vue?vue&type=style&index=0&id=8146ab58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8146ab58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VFlex,VForm,VIcon,VRadio,VRadioGroup,VTextField})
